import * as React from "react";

export const ErrorMessage: React.SFC<any> = props => {
  return <div className="error-message">{props.children}</div>;
};
